import dbee from '@os/dbee';

export function dismissedStorage() {
	const NS = 'alerts.dismissed';
	const storage = dbee(NS);
	return {
		get: () => storage.keys().filter(storage.get) || [],
		set: (key) => { storage.set(key, true); },
		unset: (key) => { storage.set(key, false); }
	};
}
